<template>
  <div class="state1">
    <el-tabs
      type="card"
      v-model="editableTabsValue"
      @tab-remove="onRemovePaperRecord"
    >
      <el-tab-pane name="first">
        <span slot="label"><i class="el-icon-edit-outline"></i> 待考试卷</span>
        <div class="wait-panel-wrapper">
          <!-- Top Header Strip -->
          <div class="wait-header-strip">
            <div class="header-info">
              待考试卷: <span class="count">{{ futureExam.length }}份</span>
            </div>
            <div class="extraction-form">
              <span class="label">提取码</span>
              <el-input
                v-model="joinCodeList.joinCode"
                placeholder="请输入提取码"
                size="small"
              ></el-input>
              <el-button
                type="primary"
                @click="onSubmit"
                :disabled="enableSubmit"
                size="small"
                >提取试卷</el-button
              >
            </div>
          </div>

                    <!-- 2026年大学生数学能力水平测试（CMT-GX、GT）专属考试卡片 -->
          <div class="cmt-exam-container" v-if="cmtExamList && cmtExamList.length > 0">
            <div class="cmt-header-title">
              <div class="title-main">2026年大学生数学能力水平测试</div>
              <div class="title-sub">(CMT-GX、GT)</div>
            </div>
            <div class="cmt-divider"></div>
            <div class="cmt-section-label">考试科目</div>
            <div class="cmt-subject-group">
              <div
                v-for="(sub, sidx) in cmtSubjectList"
                :key="'cmt-sub-' + sidx"
                :class="['cmt-subject-row', { 'is-active': currentSelectedCmtSubject && currentSelectedCmtSubject.id === sub.id, 'is-disabled': !sub.hasExam }]"
                @click="onSelectCmtSubject(sub)"
              >
                <div class="cmt-icon-box">
                  <i :class="sub.icon"></i>
                </div>
                <div class="cmt-subject-text">
                  《{{ sub.name }}》
                </div>
                <div class="cmt-subject-tag" v-if="sub.code">
                  ({{ sub.code }})
                </div>
                <div class="cmt-subject-badge" v-if="sub.statusText">
                  <el-tag size="mini" :type="sub.statusTagType">{{ sub.statusText }}</el-tag>
                </div>
              </div>
            </div>
            <!-- 开考时间、时长及提取码输入区域 -->
            <div class="cmt-timing-bar" v-if="currentSelectedCmtSubject && currentSelectedCmtSubject.hasExam">
              <div class="timing-left">
                <span class="timing-item"><i class="el-icon-time"></i> 开考时间: {{ currentSelectedCmtSubject.startTimeStr }}</span>
                <span class="timing-item"><i class="el-icon-timer"></i> 考试时长: {{ currentSelectedCmtSubject.durationMinutes }}分钟</span>
                <span class="timing-item">
                  <el-tag size="mini" :type="currentSelectedCmtSubject.isExtracted ? 'success' : 'warning'">
                    <i :class="currentSelectedCmtSubject.isExtracted ? 'el-icon-check' : 'el-icon-lock'"></i>
                    {{ currentSelectedCmtSubject.isExtracted ? '试卷已提取' : '试卷未提取' }}
                  </el-tag>
                </span>
              </div>
              <!-- 提取码输入框 -->
              <div class="cmt-extract-form" v-if="!currentSelectedCmtSubject.isExtracted">
                <span class="extract-label"><i class="el-icon-key"></i> 提取码:</span>
                <el-input
                  v-model.trim="cmtJoinCode"
                  placeholder="请输入提取码"
                  size="small"
                  class="extract-input"
                  maxlength="10"
                  @keyup.enter.native="onExtractCmtExam"
                ></el-input>
                <el-button
                  type="primary"
                  size="small"
                  :loading="extractingCmt"
                  :disabled="!cmtJoinCode"
                  @click="onExtractCmtExam"
                >
                  提取试卷
                </el-button>
              </div>
              <div class="timing-right" v-else-if="!currentSelectedCmtSubject.isStarted && !currentSelectedCmtSubject.isEnded">
                <span class="timing-status-tip">
                  <i class="el-icon-warning-outline"></i> 尚未到开考时间，请耐心等待
                </span>
              </div>
            </div>

            <div class="cmt-btn-row">
              <el-button
                type="primary"
                class="cmt-action-btn"
                :disabled="!canStartCmtExam"
                @click="onStartCmtExam"
              >
                {{ cmtStartBtnText }}
              </el-button>
              <el-button
                type="primary"
                class="cmt-action-btn cmt-submit-btn"
                :disabled="!canSubmitCmtExam"
                @click="onSubmitCmtExam"
              >
                交卷
              </el-button>
            </div>
          </div>

          <!-- Exam Card List -->
          <div class="exam-card-list">
            <el-empty
              v-if="futureExam.length === 0 && (!cmtExamList || cmtExamList.length === 0)"
              description="目前没有待考试卷"
              :image-size="100"
            ></el-empty>

            <div
              v-for="(pexam, pindex) in futureExam"
              :key="'wait-paper-' + pindex"
              class="new-exam-card"
            >
              <div class="card-dots"></div>
              <div class="card-content">
                <div class="card-top">
                  <div class="exam-icon">
                    <i class="el-icon-document"></i>
                  </div>
                  <div class="exam-title" :title="pexam.examinationName">
                    《{{ pexam.examinationName }}》
                  </div>
                </div>
                <div class="card-bottom">
                  <div class="info-item">
                    <i class="el-icon-time"></i>
                    <span>开考时间: {{ pexam.examinationDateTime }}</span>
                  </div>
                  <div class="info-item">
                    <i class="el-icon-timer"></i>
                    <span
                      >时长:
                      {{
                        pexam.examinationMinute ||
                          pexam.examinationMinutes ||
                          0
                      }}分钟</span
                    >
                  </div>
                </div>
              </div>
              <div class="card-actions">
                <!-- If matched extraction -->
                <el-button
                  v-if="pexam.id === extractedPaperId"
                  :type="effective === '开始考试' ? 'primary' : 'info'"
                  size="small"
                  @click="detail(examinationList)"
                  :disabled="effective !== '开始考试'"
                >
                  <i class="el-icon-edit-outline"></i>
                  {{ effective }}
                </el-button>
                <!-- Default state: Unextracted -->
                <el-button v-else type="info" disabled size="small">
                  <i class="el-icon-edit-outline"></i>
                  未提取
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane name="second" :disabled="hasExam">
        <span @click="hasExam ? null : fetchExamResults()" slot="label"
          ><i class="el-icon-document-copy"></i> 考试记录</span
        >
        <!-- 标题 + 工具栏 -->
        <div class="record-header-box">
          <div class="section-title">考试记录</div>
          <div class="record-toolbar">
            <el-input
              v-model.trim="statisticsSearchExamName"
              clearable
              size="small"
              placeholder="请输入试卷名称关键字"
              class="record-search-input"
              @keyup.enter.native="onSearchExamRecord"
              @clear="onSearchExamRecord"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="onSearchExamRecord"
                >搜索</el-button
              >
            </el-input>
            <el-button
              type="primary"
              size="small"
              :disabled="statisticsButtonDisabled"
              @click="openExamStatisticsDialog"
              >查看统计({{ selectedExamCount }})</el-button
            >
          </div>
        </div>
        <!-- 表格区域 -->
        <div class="record-table-container">
          <el-table
            ref="table"
            :data="tableData"
            row-key="examSer"
            height="100%"
            stripe
            :border="false"
            v-loading="tableLoading"
            element-loading-text="正在加载数据..."
            :header-cell-style="{
              background: '#f8fafc',
              color: '#475569',
              fontWeight: 'bold'
            }"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="examinationName"
              label="试卷名称"
              min-width="200"
            ></el-table-column>
            <el-table-column
              prop="userNo"
              label="学号"
              width="140"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="userName"
              label="姓名"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="majorName"
              label="专业"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="totalScore"
              label="总分"
              width="90"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="maintopicScore"
              label="主观题分数"
              width="110"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="checkExamRecord(scope.row)"
                  type="text"
                  size="small"
                  class="action-btn"
                  :disabled="!scope.row.canChecked"
                  >查看记录</el-button
                >
              </template>
            </el-table-column>
            <template slot="empty">
              <el-empty description="暂无考试记录"></el-empty>
            </template>
          </el-table>
        </div>

        <el-dialog
          :title="statisticsDialogTitle"
          :visible.sync="examStatisticsVisible"
          fullscreen
          append-to-body
          custom-class="exam-statistics-dialog"
          :close-on-click-modal="false"
          @close="onStatisticsDialogClose"
        >
          <div v-loading="statisticsLoading" class="statistics-dialog-body">
            <el-tabs v-model="statisticsActiveTab" class="statistics-tabs">
              <el-tab-pane label="按知识点" name="knowledge">
                <el-table
                  :data="statisticsData.byKnowledge"
                  class="statistics-table"
                  height="calc(100vh - 260px)"
                >
                  <el-table-column
                    prop="name"
                    label="知识点"
                    min-width="220"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="total"
                    label="题目总数"
                    width="120"
                  ></el-table-column>
                  <el-table-column
                    prop="rightCount"
                    label="答对题数"
                    width="120"
                  ></el-table-column>
                  <el-table-column
                    prop="wrongCount"
                    label="答错题数"
                    width="120"
                  ></el-table-column>
                  <el-table-column label="正确率" width="120">
                    <template slot-scope="scope">
                      {{ formatCorrectRate(scope.row.correctRate) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="proficiency"
                    label="掌握程度"
                    min-width="140"
                  ></el-table-column>
                  <template slot="empty">
                    <el-empty description="暂无统计数据"></el-empty>
                  </template>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="按题型" name="questionType">
                <el-table
                  :data="statisticsData.byQuestionType"
                  class="statistics-table"
                  height="calc(100vh - 260px)"
                >
                  <el-table-column
                    prop="name"
                    label="题型"
                    min-width="180"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="total"
                    label="题目总数"
                    width="120"
                  ></el-table-column>
                  <el-table-column
                    prop="rightCount"
                    label="答对题数"
                    width="120"
                  ></el-table-column>
                  <el-table-column
                    prop="wrongCount"
                    label="答错题数"
                    width="120"
                  ></el-table-column>
                  <el-table-column label="正确率" width="120">
                    <template slot-scope="scope">
                      {{ formatCorrectRate(scope.row.correctRate) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="proficiency"
                    label="掌握程度"
                    min-width="140"
                  ></el-table-column>
                  <template slot="empty">
                    <el-empty description="暂无统计数据"></el-empty>
                  </template>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="综合" name="mix">
                <el-table
                  :data="statisticsData.byKnowledgeAndQuestionType"
                  class="statistics-table"
                  height="calc(100vh - 260px)"
                >
                  <el-table-column
                    prop="name"
                    label="知识点"
                    min-width="220"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="secondName"
                    label="题型"
                    min-width="160"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="total"
                    label="题目总数"
                    width="120"
                  ></el-table-column>
                  <el-table-column
                    prop="rightCount"
                    label="答对题数"
                    width="120"
                  ></el-table-column>
                  <el-table-column
                    prop="wrongCount"
                    label="答错题数"
                    width="120"
                  ></el-table-column>
                  <el-table-column label="正确率" width="120">
                    <template slot-scope="scope">
                      {{ formatCorrectRate(scope.row.correctRate) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="proficiency"
                    label="掌握程度"
                    min-width="140"
                  ></el-table-column>
                  <template slot="empty">
                    <el-empty description="暂无统计数据"></el-empty>
                  </template>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-dialog>
      </el-tab-pane>

      <el-tab-pane
        v-for="(pdata, pindex) in paperRecords"
        :key="'paper-' + pindex"
        :name="pdata.examSer"
        :closable="true"
      >
        <span slot="label"
          ><i class="el-icon-edit-outline"></i> {{ pdata.examName }}</span
        >
        <preView :paperData="pdata"></preView>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { IsEmptyString } from "@/util/stringutl";
import {
  getStudentCmtExam,
  getJoinCode,
  getStudentExaming,
  pushStudentType,
  getTimes,
  getStudentExaminationList,
  getUserDetail,
  getLastUserExamResults,
  getStudentExamStatistics,
  hasExamination
} from "@/api/student";
import preView from "@/components/preView4";

export default {
  name: "ExaminationIndex",
  components: { preView },
  data() {
    return {
      openstate: 1,
      tableData: [],
      tableLoading: false,
      futureExam: [],
      waitExaming: [],
      editableTabsValue: "first",
      hasExam: false,
      joinCodeList: {
        joinCode: "",
        localIp: "172.168.10.207"
      },
      examinationList: {},
      examinationMinutes: "",
      effective: "未开始",
      formInline: {},
      numlimit: 100,
      paperRecords: [],
      dom: null,
      times: null,
      studenttype: false,
      goInto: 0,
      examinationCoursesName: "",
      examinationMinute: "",
      studentNo: {},
      selectedExamRows: [],
      examStatisticsVisible: false,
      statisticsLoading: false,
      statisticsActiveTab: "knowledge",
      statisticsSearchExamName: "",
      statisticsData: {
        byKnowledge: [],
        byQuestionType: [],
        byKnowledgeAndQuestionType: []
      },
      nowTime: Date.now(),
      timeOffset: 0,
      clockTimer: null,
      selectedCmtSubjectId: "GX",
      cmtJoinCode: "",
      extractingCmt: false,
      extractedPaperIds: [],
      extractedPaperId: null,
      cmtExamList: [],
      selectedCmtSubject: null,
      cmtSubjectDefinitions: [
        { id: "GT", name: "概率论与数理统计", code: "GT", cmtKey: "GT", icon: "el-icon-document" },
        { id: "GX", name: "高等数学及线性代数", code: "GX", cmtKey: "GX", icon: "el-icon-reading" }
      ]
    };
  },
  computed: {
    cmtSubjectList() {
      const currentTimestamp = this.nowTime;
      return this.cmtSubjectDefinitions.map(def => {
        const matchedExam = (this.cmtExamList || []).find(e => e.cmtSubject === def.cmtKey);
        let hasExam = !!matchedExam;
        let statusText = "未安排";
        let statusTagType = "info";
        let isStarted = false;
        let isEnded = false;
        let canStart = false;
        let isExtracted = false;
        let startTimeStr = "";
        let durationMinutes = 0;

        if (matchedExam) {
          startTimeStr = matchedExam.examinationDateTime || "";
          durationMinutes = Number(matchedExam.examinationMinute || matchedExam.examinationMinutes) || 0;

          const needsJoinCode = matchedExam.joinCode != null && Number(matchedExam.joinCode) > 0;
          if (!needsJoinCode) {
            isExtracted = true;
          } else {
            isExtracted = (matchedExam.review === 1) || this.extractedPaperIds.includes(matchedExam.id) || (this.extractedPaperId === matchedExam.id);
          }

          if (matchedExam.examStatus === 1 || matchedExam.examStatus === 2) {
            statusText = "已交卷";
            statusTagType = "success";
            isEnded = true;
          } else if (startTimeStr) {
            const startTime = new Date(String(startTimeStr).replace(/-/g, "/")).getTime();
            const endTime = startTime + durationMinutes * 60 * 1000;

            if (currentTimestamp < startTime) {
              statusText = isExtracted ? "未开始(已提取)" : "未提取";
              statusTagType = isExtracted ? "info" : "warning";
            } else if (currentTimestamp >= startTime && currentTimestamp <= endTime) {
              isStarted = true;
              if (isExtracted) {
                statusText = "考试中";
                statusTagType = "danger";
                canStart = true;
              } else {
                statusText = "未提取";
                statusTagType = "warning";
              }
            } else {
              statusText = "已结束";
              statusTagType = "info";
              isEnded = true;
            }
          } else {
            statusText = isExtracted ? "待考试" : "未提取";
            statusTagType = isExtracted ? "primary" : "warning";
            canStart = isExtracted;
          }
        }

        return {
          ...def,
          hasExam,
          exam: matchedExam || null,
          statusText,
          statusTagType,
          isStarted,
          isEnded,
          canStart,
          isExtracted,
          startTimeStr,
          durationMinutes
        };
      });
    },
    currentSelectedCmtSubject() {
      if (!this.cmtSubjectList || this.cmtSubjectList.length === 0) return null;
      return (
        this.cmtSubjectList.find(s => s.id === this.selectedCmtSubjectId) ||
        this.cmtSubjectList.find(s => s.hasExam) ||
        this.cmtSubjectList[0]
      );
    },
    canStartCmtExam() {
      const sub = this.currentSelectedCmtSubject;
      if (!sub || !sub.hasExam || !sub.exam) {
        return false;
      }
      return !!sub.canStart && !!sub.isExtracted;
    },
    canSubmitCmtExam() {
      const sub = this.currentSelectedCmtSubject;
      if (!sub || !sub.hasExam || !sub.exam) {
        return false;
      }
      return sub.isStarted && !sub.isEnded && sub.exam.examStatus !== 1 && sub.exam.examStatus !== 2;
    },
    cmtStartBtnText() {
      const sub = this.currentSelectedCmtSubject;
      if (!sub || !sub.hasExam || !sub.exam) {
        return "开始考试";
      }
      if (sub.exam.examStatus === 1 || sub.exam.examStatus === 2) {
        return "已交卷";
      }
      if (!sub.isExtracted) {
        return "输入提取码进入考试";
      }
      if (!sub.isStarted && !sub.isEnded) {
        return "未到开考时间";
      }
      if (sub.isEnded) {
        return "考试已结束";
      }
      return "开始考试";
    },
    enableSubmit() {
      const regex = /^[0-9]+$/;
      return (
        IsEmptyString(this.joinCodeList.joinCode) ||
        !regex.test(this.joinCodeList.joinCode)
      );
    },
    selectedExamCount() {
      return this.selectedExamRows.length;
    },
    statisticsButtonDisabled() {
      return this.selectedExamCount === 0;
    },
    statisticsDialogTitle() {
      if (this.selectedExamRows.length > 1) {
        return `选定考试(${this.selectedExamRows.length})的合并统计信息`;
      }
      const selectedRow = this.selectedExamRows[0];
      const examName =
        (selectedRow && selectedRow.examinationName) || "考试记录";
      return `${examName}的统计信息`;
    }
  },
  created() {
    this.syncServerTime();
    this.clockTimer = setInterval(() => {
      this.nowTime = Date.now() + this.timeOffset;
    }, 1000);
    this.checkExamStatus();
    this.examTimer = setInterval(this.checkExamStatus, 15000); // 15秒轮询一次考试状态
  },
  mounted() {
    this.getCurrentExamList();
    this.fetchCmtExamList();
    this.$nextTick(() => {
      if (this.$refs.table && this.$refs.table.bodyWrapper) {
        this.dom = this.$refs.table.bodyWrapper;
        this.dom.addEventListener("scroll", this.onTableScroll);
      }
    });
  },
  beforeDestroy() {
    clearTimeout(this.times);
    this.times = null;
    if (this.clockTimer) {
      clearInterval(this.clockTimer);
      this.clockTimer = null;
    }
    if (this.examTimer) {
      clearInterval(this.examTimer);
    }
    if (this.dom) {
      this.dom.removeEventListener("scroll", this.onTableScroll);
    }
  },
  methods: {
    async syncServerTime() {
      try {
        const res = await getTimes();
        if (res && res.data && res.data.data) {
          const serverDate = new Date(String(res.data.data).replace(/-/g, "/")).getTime();
          this.timeOffset = serverDate - Date.now();
          this.nowTime = Date.now() + this.timeOffset;
        }
      } catch (e) {}
    },
    async fetchCmtExamList() {
      try {
        const res = await getStudentCmtExam();
        let list = (res && res.data) || [];
        this.cmtExamList = Array.isArray(list) ? list : [];
        if (this.cmtExamList.length > 0) {
          const firstAvailable = this.cmtSubjectList.find(s => s.hasExam);
          if (firstAvailable) {
            this.selectedCmtSubjectId = firstAvailable.id;
          }
        }
      } catch (err) {
        console.error("fetchCmtExamList error:", err);
        this.cmtExamList = [];
      }
    },
    onSelectCmtSubject(sub) {
      if (!sub.hasExam) {
        this.$message.info(`您暂未被指定参加《${sub.name}》的测试`);
        return;
      }
      this.selectedCmtSubjectId = sub.id;
    },
    async onExtractCmtExam() {
      if (!this.cmtJoinCode) {
        this.$message.warning("请输入考试提取码");
        return;
      }
      this.extractingCmt = true;
      try {
        const res = await getJoinCode({
          joinCode: this.cmtJoinCode,
          localIp: this.joinCodeList.localIp
        });
        if (res.code === 200 && res.data) {
          this.$message.success("试卷提取成功！");
          const extractedId = res.data.id;
          if (!this.extractedPaperIds.includes(extractedId)) {
            this.extractedPaperIds.push(extractedId);
          }
          this.extractedPaperId = extractedId;
          this.cmtJoinCode = "";
          await this.fetchCmtExamList();
        } else {
          this.$message.error((res && res.message) || "提取码错误或试卷不存在");
        }
      } catch (err) {
        this.$message.error((err && err.message) || "提取失败，请检查提取码");
      } finally {
        this.extractingCmt = false;
      }
    },
    onStartCmtExam() {
      const sub = this.currentSelectedCmtSubject;
      if (!sub || !sub.hasExam || !sub.exam) {
        this.$message.warning("请先选择要参加的考试科目");
        return;
      }
      const exam = sub.exam;
      if (exam.examStatus === 1 || exam.examStatus === 2) {
        this.$message.warning("您已提交该科目试卷，无法重复参加");
        return;
      }

      // Check if extracted
      if (!sub.isExtracted) {
        this.$prompt("请输入本次考试提取码完成试卷提取", "提取试卷", {
          confirmButtonText: "确定提取",
          cancelButtonText: "取消",
          inputPlaceholder: "请输入考试提取码",
          inputPattern: /^[0-9]+$/,
          inputErrorMessage: "提取码格式不正确（必须为数字）"
        }).then(async ({ value }) => {
          this.cmtJoinCode = value;
          await this.onExtractCmtExam();
        }).catch(() => {});
        return;
      }

      const now = this.nowTime;
      const startTime = new Date(String(exam.examinationDateTime).replace(/-/g, "/")).getTime();
      const duration = (exam.examinationMinute || exam.examinationMinutes || 0) * 60 * 1000;
      const endTime = startTime + duration;

      if (now < startTime) {
        this.$message.warning(`该考试未到开始时间（开考时间：${exam.examinationDateTime}），请耐心等待`);
        return;
      }
      if (now > endTime) {
        this.$message.warning("该考试已经结束，无法进入考试");
        return;
      }
      this.detail(exam);
    },
    onSubmitCmtExam() {
      const sub = this.currentSelectedCmtSubject;
      if (!sub || !sub.hasExam || !sub.exam) {
        this.$message.warning("请先选择考试科目");
        return;
      }
      const exam = sub.exam;
      if (exam.examStatus === 1 || exam.examStatus === 2) {
        this.$message.info("您已交卷，测试已完成");
        return;
      }
      const now = this.nowTime;
      const startTime = new Date(String(exam.examinationDateTime).replace(/-/g, "/")).getTime();
      if (now < startTime) {
        this.$message.warning("该考试尚未开始");
        return;
      }
      this.$confirm(`确认对《${sub.name}》进行交卷？请确保已在答题界面完成所有作答。`, "交卷确认", {
        confirmButtonText: "确定交卷",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$message.info("交卷请在答题界面点击【交卷】以保存作答数据");
      }).catch(() => {});
    },
    checkExamStatus() {
      hasExamination()
        .then(res => {
          if (res && (res.code === 200 || res.code === 0)) {
            this.hasExam = res.data === true;
            if (this.hasExam && this.editableTabsValue === "second") {
              this.editableTabsValue = "first";
            }
          }
        })
        .catch(err => console.error(err));
    },
    onTableScroll() {
      if (!this.dom) {
        return;
      }
      const scorrheight = this.dom.clientHeight + this.dom.scrollTop;
      if (this.dom.scrollHeight - scorrheight < 10) {
        this.numlimit += 10;
        this.fetchExamResults();
      }
    },
    async fetchExamResults() {
      this.tableLoading = true;
      getLastUserExamResults({
        limnumber: this.numlimit,
        examName: this.statisticsSearchExamName
      })
        .then(res => {
          const examRows = Array.isArray(res.data) ? res.data : [];
          this.tableData = examRows.map(item => {
            item.canChecked =
              item.canChecked && !IsEmptyString(item.answerinfo);
            item.KgtopicScore =
              (item.score || 0) +
              (item.multiScore || 0) +
              (item.judgeScore || 0);
            item.maintopicScore =
              (item.fillXScore || 0) +
              (item.proofXScore || 0) +
              (item.anwsXScore || 0);
            return item;
          });
          this.selectedExamRows = [];
          if (this.$refs.table) {
            this.$refs.table.clearSelection();
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    onSearchExamRecord() {
      this.numlimit = 100;
      this.fetchExamResults();
    },
    handleSelectionChange(rows) {
      this.selectedExamRows = Array.isArray(rows) ? rows : [];
    },
    async openExamStatisticsDialog() {
      if (this.selectedExamRows.length === 0) {
        this.$message.warning("请先选择考试记录");
        return;
      }
      const ids = this.selectedExamRows
        .map(row => row.id)
        .filter(id => !IsEmptyString(id));

      if (ids.length === 0) {
        this.$message.error("选中的记录缺少有效标识，无法获取统计信息");
        return;
      }

      this.resetStatisticsState(true);
      this.examStatisticsVisible = true;
      this.statisticsLoading = true;

      try {
        const res = await getStudentExamStatistics(ids);
        if (res.code !== 200 || !res.data) {
          this.$message.error(res.message || "获取统计数据失败");
          return;
        }
        this.statisticsData = {
          byKnowledge: this.normalizeStatisticsList(res.data.byKnowledge),
          byQuestionType: this.normalizeStatisticsList(res.data.byQuestionType),
          byKnowledgeAndQuestionType: this.normalizeStatisticsList(
            res.data.byKnowledgeAndQuestionType
          )
        };
      } catch (error) {
        this.$message.error("获取统计数据失败，请稍后重试");
      } finally {
        this.statisticsLoading = false;
      }
    },
    onStatisticsDialogClose() {
      this.examStatisticsVisible = false;
      this.resetStatisticsState(true);
    },
    resetStatisticsState(clearData = false) {
      this.statisticsLoading = false;
      this.statisticsActiveTab = "knowledge";
      if (clearData) {
        this.statisticsData = {
          byKnowledge: [],
          byQuestionType: [],
          byKnowledgeAndQuestionType: []
        };
      }
    },
    normalizeStatisticsList(list) {
      const source = Array.isArray(list) ? list : [];
      return source.map(item => ({
        name: (item && item.name) || "-",
        secondName: (item && item.secondName) || "-",
        total: this.toSafeNumber(item && item.total),
        rightCount: this.toSafeNumber(item && item.rightCount),
        wrongCount: this.toSafeNumber(item && item.wrongCount),
        correctRate: item && item.correctRate,
        proficiency: (item && item.proficiency) || "-"
      }));
    },
    toSafeNumber(value) {
      const numericValue = Number(value);
      return Number.isFinite(numericValue) ? numericValue : 0;
    },
    formatCorrectRate(value) {
      if (value === null || value === undefined || value === "") {
        return "0.00%";
      }
      if (typeof value === "string" && value.includes("%")) {
        return value;
      }
      const numericValue = Number(value);
      if (!Number.isFinite(numericValue)) {
        return "0.00%";
      }
      const decimal = numericValue > 1 ? numericValue / 100 : numericValue;
      return `${(decimal * 100).toFixed(2)}%`;
    },
    async onRefreshList() {
      let respon = await getStudentExaming();
      if (respon.code == 200) {
        this.waitExaming = respon.data;
      }
    },
    async getCurrentExamList() {
      let respon = await getStudentExaminationList();
      if (respon.code == 200) {
        this.futureExam = respon.data;
      } else {
        this.futureExam = [];
      }
    },
    onSubmit() {
      const that = this;
      if (IsEmptyString(this.joinCodeList.joinCode)) {
        this.$message.error("加入码为空");
        return;
      }
      const loading = that.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      getJoinCode({
        joinCode: this.joinCodeList.joinCode,
        localIp: this.joinCodeList.localIp
      })
        .then(res => {
          if (res.code === 15004) {
            this.$message.error(res.message);
            return Promise.reject(new Error(res.message));
          } else if (res.code === 200) {
            // Updated: instead of just switching view, we track the extracted ID
            this.extractedPaperId = res.data.id;
            if (!this.extractedPaperIds.includes(res.data.id)) {
              this.extractedPaperIds.push(res.data.id);
            }
            this.openstate = 2;
            that.examinationList = res.data;
            localStorage.setItem("paperID", that.examinationList.id);
            if (this.times) {
              clearTimeout(this.times);
            }
            that.checkExaminationStatus();
            this.fetchCmtExamList();
            this.$message.success("试卷提取成功！");
          } else if (res.code === 15003) {
            this.$message.error(res.message);
            return Promise.reject(new Error(res.message));
          } else {
            this.$message.error(res.message);
            return Promise.reject(new Error(res.message));
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    async checkExaminationStatus() {
      let that = this;
      let currentDate;
      await getTimes()
        .then(res => {
          const strdata = res.data.data.replace(/-/g, "/");
          currentDate = new Date(strdata).getTime();
        })
        .catch(err => {
          this.$message.error(err);
        });
      if (this.times) {
        clearTimeout(this.times);
      }
      let examinationDateTime = this.examinationList.examinationDateTime.replace(
        /-/g,
        "/"
      );
      examinationDateTime = new Date(examinationDateTime).getTime();
      const distancetm = currentDate - examinationDateTime;
      if (
        currentDate >
        examinationDateTime + that.examinationList.examinationMinute * 60 * 1000
      ) {
        this.effective = "考试结束";
      } else if (
        examinationDateTime < currentDate &&
        distancetm < that.examinationList.examinationMinute * 60 * 1000
      ) {
        if (this.times) {
          clearTimeout(this.times);
        }
        this.effective = "开始考试";
      } else if (examinationDateTime > currentDate) {
        this.effective = "未开始";
        if (examinationDateTime - currentDate > 60000) {
          this.times = setTimeout(() => {
            this.checkExaminationStatus();
          }, 60000);
        } else {
          this.times = setTimeout(() => {
            this.checkExaminationStatus();
          }, 5000);
        }
      }
    },
    screenfullEnter() {
      const el = document.documentElement;
      const eventEnter =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen;
      if (typeof eventEnter !== "undefined" && eventEnter) {
        eventEnter.call(el);
      }
    },
    async detail(item) {
      const targetExam = item || this.examinationList;
      if (!targetExam) {
        this.$message.error("考试信息不存在");
        return;
      }
      if (targetExam) {
        const needsJoinCode = targetExam.joinCode != null && Number(targetExam.joinCode) > 0;
        if (needsJoinCode) {
          const isExtracted = (targetExam.review === 1) || this.extractedPaperIds.includes(targetExam.id) || (this.extractedPaperId === targetExam.id);
          if (!isExtracted) {
            this.$message.warning("请先输入提取码提取试卷");
            return;
          }
        }
      }
      if (targetExam.examinationDateTime) {
        const now = this.nowTime || Date.now();
        const startTime = new Date(String(targetExam.examinationDateTime).replace(/-/g, "/")).getTime();
        const duration = (targetExam.examinationMinute || targetExam.examinationMinutes || 0) * 60 * 1000;
        const endTime = startTime + duration;
        if (now < startTime) {
          this.$message.warning(`考试未到开始时间（开考时间：${targetExam.examinationDateTime}），无法进入`);
          return;
        }
        if (now > endTime) {
          this.$message.warning("考试已经结束，无法进入");
          return;
        }
      }
      this.examinationMinutes = targetExam.examinationMinute || targetExam.examinationMinutes;
      this.studenttype = true;
      const that = this;
      that.goInto++;
      that.examinationCoursesName = targetExam.examinationCoursesName;
      that.examinationMinute = targetExam.examinationMinute || targetExam.examinationMinutes;
      this.screenfullEnter();
      that.$router.push({
        path: "/exam",
        query: {
          studenttype: this.studenttype,
          paperId: targetExam.id,
          localIp: this.joinCodeList.localIp,
          examinationDiff: targetExam.examinationDiff,
          examinationSer: targetExam.examinationSer,
          examinationCoursesName: that.examinationCoursesName,
          examinationMinute: that.examinationMinute,
          examinationName: targetExam.examinationName,
          startTime: targetExam.examinationDateTime
        }
      });
      this.studentNo = JSON.parse(localStorage.getItem("userInfo"));
      let params = {
        message: "学生开始考试，",
        operateName: "开始考试",
        operateType: 1,
        paperID: that.examinationList.id,
        userID: this.studentNo.studentId
      };
      pushStudentType(params).then(() => {});
    },
    async checkExamRecord(userrs) {
      let exist = false;
      this.paperRecords.forEach(pprec => {
        if (pprec.examSer === userrs.examSer) {
          this.editableTabsValue = userrs.examSer;
          exist = true;
          return;
        }
      });
      if (!exist) {
        const loading = this.$loading({
          lock: true,
          text: "正在加载试卷详情，请稍候...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        try {
          let res = await getUserDetail(userrs.examSer);
          if (res.code == 200 && res.success) {
            let npaperec = {};
            npaperec.examSer = userrs.examSer;
            npaperec.examName = userrs.examinationName;
            npaperec.answers = JSON.parse(userrs.answerinfo);
            npaperec.collegename = userrs.collegename;
            npaperec.questions = res.data;
            npaperec.grade = userrs.grade;
            npaperec.userName = userrs.userName;
            npaperec.className = userrs.className;
            npaperec.userNo = userrs.userNo;
            npaperec.majorName = userrs.majorName;
            npaperec.score = userrs.score;
            npaperec.multiScore = userrs.multiScore;
            npaperec.anwsXScore = userrs.anwsXScore;
            npaperec.fillXScore = userrs.fillXScore;
            npaperec.judgeScore = userrs.judgeScore;
            npaperec.proofXScore = userrs.proofXScore;
            npaperec.totalScore = userrs.totalScore;
            // 获取并传递不定项给分开关（如果存在）
            npaperec.isOpenMultiChoice = userrs.isOpenMultiChoice;
            this.paperRecords.push(npaperec);
            this.editableTabsValue = userrs.examSer;
          } else {
            this.$message.error(res.message || "获取试卷详情失败");
          }
        } catch (error) {
          this.$message.error("加载失败，请重试");
        } finally {
          loading.close();
        }
      }
    },
    onRemovePaperRecord(tabparam) {
      let fltpaperRecords = this.paperRecords.filter(element => {
        return element.examSer !== tabparam;
      });
      this.paperRecords = fltpaperRecords;
      let pcount = this.paperRecords.length;
      if (pcount === 0) {
        this.editableTabsValue = "second";
      } else {
        this.editableTabsValue = this.paperRecords[pcount - 1].examSer;
      }
    }
  }
};
</script>

<style scoped lang="scss">
/* ===== 2026年大学生数学能力水平测试（CMT）专属卡片样式 ===== */
.cmt-exam-container {
  background: #ffffff;
  border-radius: 12px;
  padding: 36px 44px;
  margin: 16px 0 24px 0;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.05);
  border: 1px solid #edf2f7;
  max-width: 860px;

  .cmt-timing-bar {
    margin-top: 16px;
    padding: 12px 18px;
    background: #f8fafc;
    border: 1px dashed #cbd5e1;
    border-radius: 8px;
    font-size: 14px;
    color: #475569;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;

    .timing-left {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
    }

    .timing-item {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font-weight: 500;
      i {
        color: #3b82f6;
      }
    }

    .timing-status-tip {
      color: #e6a23c;
      font-weight: 500;
      display: inline-flex;
      align-items: center;
      gap: 4px;
    }

    .cmt-extract-form {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-left: auto;

      .extract-label {
        font-weight: 600;
        color: #1e293b;
        font-size: 14px;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        i {
          color: #f59e0b;
        }
      }

      .extract-input {
        width: 140px;
      }
    }
  }

  .cmt-header-title {
    .title-main {
      font-size: 26px;
      font-weight: 800;
      color: #111827;
      line-height: 1.35;
      letter-spacing: 0.5px;
    }
    .title-sub {
      font-size: 24px;
      font-weight: 800;
      color: #111827;
      line-height: 1.35;
      margin-top: 4px;
    }
  }

  .cmt-divider {
    height: 1px;
    background: #e2e8f0;
    margin: 24px 0 20px 0;
  }

  .cmt-section-label {
    font-size: 19px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 18px;
  }

  .cmt-subject-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 28px;
  }

  .cmt-subject-row {
    display: flex;
    align-items: center;
    padding: 12px 18px;
    border-radius: 8px;
    cursor: pointer;
    background: #f8fafc;
    border: 1px solid transparent;
    transition: all 0.2s ease;

    &:hover {
      background: #eff6ff;
      border-color: #bfdbfe;
    }

    &.is-active {
      background: #eff6ff;
      border-color: #3b82f6;
      box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);

      .cmt-subject-text {
        color: #1d4ed8;
        font-weight: 700;
      }
      .cmt-icon-box {
        color: #2563eb;
      }
    }

    &.is-disabled {
      opacity: 0.55;
      cursor: not-allowed;
      background: #f1f5f9;
      &:hover {
        background: #f1f5f9;
        border-color: transparent;
      }
    }

    .cmt-icon-box {
      font-size: 22px;
      color: #64748b;
      margin-right: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .cmt-subject-text {
      font-size: 17px;
      font-weight: 600;
      color: #334155;
    }

    .cmt-subject-tag {
      font-size: 14px;
      color: #64748b;
      margin-left: 6px;
    }

    .cmt-subject-badge {
      margin-left: auto;
    }
  }

  .cmt-btn-row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 28px;
    margin-top: 24px;

    .cmt-action-btn {
      min-width: 130px;
      height: 44px;
      font-size: 16px;
      font-weight: 600;
      border-radius: 8px;
      background: #3b71ca;
      border-color: #3b71ca;
      transition: all 0.2s;

      &:hover {
        background: #2b5cb8;
        border-color: #2b5cb8;
      }
    }

    .cmt-submit-btn {
      background: #3b71ca;
      border-color: #3b71ca;

      &:hover {
        background: #2b5cb8;
        border-color: #2b5cb8;
      }
    }
  }
}

@import "@/assets/styles/examination-page.scss";

/* ===== 考试记录 Tab 专属布局 ===== */

/* 标题行：左侧功能标题 + 右侧工具栏 */
.record-header-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-top: 4px;

  .section-title {
    font-size: 18px;
    font-weight: 800;
    color: #1e293b;
    position: relative;
    padding-left: 12px;
    flex-shrink: 0;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 18px;
      background: #2563eb;
      border-radius: 2px;
    }
  }
}

/* 搜索+按钮工具栏 */
.record-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}

.record-search-input {
  width: 320px;
  max-width: 100%;
}

/* 表格容器：撑满 Tab 内容剩余高度 */
.record-table-container {
  height: calc(100vh - 240px);
  overflow: hidden;
}

/* 操作按钮 */
.action-btn {
  font-size: 14px;
  padding: 0 4px;
}

.statistics-dialog-body {
  height: 100%;
}

.statistics-tabs {
  height: 100%;
}

::v-deep .exam-statistics-dialog {
  margin: 0 !important;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .el-dialog__body {
    flex: 1;
    overflow: hidden;
    padding: 16px 20px 20px;
  }
}
</style>
